import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  InputNumber,
  Progress,
  Row,
  Space,
  TimePicker,
  Typography,
  message,
  Tag,
  Modal,
  Select,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  SaveOutlined,
  ClockCircleOutlined,
  DashboardOutlined,
  DollarOutlined,
  ReloadOutlined,
  ClearOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import axios from "axios";
import { useLojaSelecionada } from "../../../queries/useLojaSelecionada";
import MetaDoDia from "./Pagamento/MetaDoDia";
import { Header } from "antd/es/layout/layout";

dayjs.extend(customParseFormat);

const { Title, Text } = Typography;

const criarHorario = (inicio = "08:00", fim = "18:00") => ({
  inicio,
  fim,
});

const criarDia = ({
  ativo = true,
  valorMinimo = null,
  valorMaximo = null,
  quantidadeMinima = null,
  quantidadeMaxima = null,
  horarios = [],
} = {}) => ({
  ativo,
  valorMinimo,
  valorMaximo,
  quantidadeMinima,
  quantidadeMaxima,
  horarios,
});

const estadoInicialDias = {
  segunda: criarDia(),
  terca: criarDia({
    horarios: [criarHorario("08:00", "12:00"), criarHorario("15:00", "22:00")],
  }),
  quarta: criarDia({
    horarios: [criarHorario("08:00", "18:00")],
  }),
  quinta: criarDia({
    horarios: [
      criarHorario("07:00", "09:00"),
      criarHorario("11:00", "15:00"),
      criarHorario("18:00", "22:00"),
    ],
  }),
  sexta: criarDia(),
  sabado: criarDia(),
  domingo: criarDia({
    horarios: [criarHorario("10:00", "14:00")],
  }),
};

const nomesDias = {
  segunda: "Segunda",
  terca: "Terça",
  quarta: "Quarta",
  quinta: "Quinta",
  sexta: "Sexta",
  sabado: "Sábado",
  domingo: "Domingo",
};

const formatarMoeda = (valor) =>
  Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatarHorario = (horario) => `${horario.inicio} às ${horario.fim}`;

const parserNumero = (value) => {
  if (!value) return 0;

  const somenteNumeros = value.toString().replace(/\D/g, "");

  return Number(somenteNumeros) / 100;
};

const formatterNumero = (value) => {
  if (value === null || value === undefined) return "";

  return Number(value).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

const toDayjsTime = (value, fallback = "08:00") => {
  const time = dayjs(value, "HH:mm", true);
  if (time.isValid()) return time;

  const fallbackTime = dayjs(fallback, "HH:mm", true);
  if (fallbackTime.isValid()) return fallbackTime;

  return dayjs("08:00", "HH:mm", true);
};

const Automacao = () => {
  const accessToken = window.localStorage.getItem("accessToken");
  const { data: lojaSelecionada } = useLojaSelecionada();



  const [formasDePagamento, setFormasDePagamento] = useState([]);
  const [formasPagamentoConfig, setFormasPagamentoConfig] = useState({
    formaPagamento1: "01",
    formaPagamento2: null,
    formaPagamento3: null,
  });


  useEffect(() => {
    if (lojaSelecionada?.id) {
      axios
        .get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${lojaSelecionada.id}/formas-pagamento`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        )
        .then((response) => {
          const options = response.data._embedded.formasPagamento.map((forma) => ({
            label: forma.descricao,
            value: forma.codigo, // 👈 STRING
          }));

          setFormasDePagamento(options);

          setFormasPagamentoConfig((prev) => ({
            ...prev,
            formaPagamento1: prev.formaPagamento1 || "01",
          }));
        })
        .catch((err) => {
          console.error(err);
          setFormasDePagamento([]);
        });
    }
  }, [lojaSelecionada?.id, accessToken]);







  const cnpj = lojaSelecionada?.cnpj || "";
  const nome = lojaSelecionada?.nome || "";
  const lojaIdSafe = lojaSelecionada?.id || "";

  const [faturamentoAtual, setFaturamentoAtual] = useState(0);
  const [status, setStatus] = useState('');
  const [horarioDefault, setHorarioDefault] = useState({
    inicio: "08:00",
    fim: "18:00",
  });

  const [faixaDefault, setFaixaDefault] = useState({
    valorMinimo: null,
    valorMaximo: null,
  });

  const [vendasDefault, setVendasDefault] = useState({
    quantidadeMinima: null,
    quantidadeMaxima: null,
  });

  const [dias, setDias] = useState(estadoInicialDias);

  const [loja, setVendasLoja] = useState(0);
  const [robo, setVendasRobo] = useState(0);
  const [reload, setReload] = useState(false);



  const [metaDia, setMetaDia] = useState({
    metaDiariaCalculada: 0,
    valorEmitidoHoje: 0,
    valorRestanteHoje: 0,
    valorLojaHoje: 0,
    valorRoboHoje: 0,
    quantidadeDeVendas: 0,
    quantidadeDeVendasFeitas: 0,
  });

  const totalEmissao = loja + robo;

  const getValorMinimoEfetivo = (dia) => {
    if (dia.valorMinimo !== null && dia.valorMinimo !== undefined) {
      return Number(dia.valorMinimo || 0);
    }
    return Number(faixaDefault.valorMinimo || 0);
  };

  const getValorMaximoEfetivo = (dia) => {
    if (dia.valorMaximo !== null && dia.valorMaximo !== undefined) {
      return Number(dia.valorMaximo || 0);
    }
    return Number(faixaDefault.valorMaximo || 0);
  };

  const getQuantidadeMinimaEfetiva = (dia) => {
    if (dia.quantidadeMinima !== null && dia.quantidadeMinima !== undefined) {
      return Number(dia.quantidadeMinima || 0);
    }
    return Number(vendasDefault.quantidadeMinima || 0);
  };

  const getQuantidadeMaximaEfetiva = (dia) => {
    if (dia.quantidadeMaxima !== null && dia.quantidadeMaxima !== undefined) {
      return Number(dia.quantidadeMaxima || 0);
    }
    return Number(vendasDefault.quantidadeMaxima || 0);
  };

  const {
    metaMensal,
    percentualMeta,
    diasDesmarcados,
    mediaMaioresRanges,
    somaMaioresRanges,
  } = useMemo(() => {
    const diasArray = Object.values(dias);

    const soma = diasArray.reduce((acc, dia) => {
      return acc + getValorMaximoEfetivo(dia);
    }, 0);

    const desmarcados = diasArray.filter((dia) => !dia.ativo).length;
    const media = soma / 7;
    const multiplicador = 30 - desmarcados * 4;
    const meta = Math.round(media * multiplicador);

    const percentual = Math.min(
      (Number(faturamentoAtual || 0) / Number(meta || 1)) * 100,
      100
    );

    return {
      metaMensal: meta,
      percentualMeta: percentual,
      diasDesmarcados: desmarcados,
      mediaMaioresRanges: media,
      somaMaioresRanges: soma,
    };
  }, [dias, faturamentoAtual, faixaDefault]);

  const atualizarDia = (diaKey, payload) => {
    setDias((prev) => ({
      ...prev,
      [diaKey]: {
        ...prev[diaKey],
        ...payload,
      },
    }));
  };

  const toggleDiaAtivo = (diaKey) => {
    atualizarDia(diaKey, {
      ativo: !dias[diaKey].ativo,
    });
  };

  const adicionarHorario = (diaKey) => {
    const horariosAtuais = dias[diaKey].horarios || [];
    atualizarDia(diaKey, {
      horarios: [...horariosAtuais, criarHorario()],
    });
  };


  const atualizarPainel = () => {

  };



  const removerHorario = (diaKey, index) => {
    const lista = [...(dias[diaKey].horarios || [])];
    lista.splice(index, 1);

    atualizarDia(diaKey, {
      horarios: lista,
    });
  };

  const atualizarHorario = (diaKey, index, campo, valor) => {
    const lista = [...(dias[diaKey].horarios || [])];
    lista[index] = {
      ...lista[index],
      [campo]: valor,
    };

    atualizarDia(diaKey, {
      horarios: lista,
    });
  };

  const limparFaixaDoDia = (diaKey) => {
    atualizarDia(diaKey, {
      valorMinimo: null,
      valorMaximo: null,
    });
  };

  const limparQuantidadeDoDia = (diaKey) => {
    atualizarDia(diaKey, {
      quantidadeMinima: null,
      quantidadeMaxima: null,
    });
  };

  useEffect(() => {
    const carregarConfig = async () => {
      if (!accessToken || !cnpj) return;

      try {
        const options = {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
        };

        const { data } = await axios.get(
          `https://apicontabil.techspdv.com.br/v1/automacao/buscar/${cnpj}`,
          options
        );

        if (!data) return;

        if (data.horarioDefault) {
          setHorarioDefault(data.horarioDefault);
        }

        if (data.faixaDefault) {
          setFaixaDefault(data.faixaDefault);
        }

        if (data.vendasDefault) {
          setVendasDefault(data.vendasDefault);
        }
        if (data.formasPagamento) {
          setFormasPagamentoConfig({
            formaPagamento1:
              normalizarCodigoForma(data.formasPagamento.formaPagamento1) || "01",
            formaPagamento2:
              normalizarCodigoForma(data.formasPagamento.formaPagamento2) || null,
            formaPagamento3:
              normalizarCodigoForma(data.formasPagamento.formaPagamento3) || null,
          });
        } else {
          setFormasPagamentoConfig({
            formaPagamento1: { codigo: "01", descricao: "Dinheiro" },
            formaPagamento2: null,
            formaPagamento3: null,
          });
        }
        if (data.dias) {
          setDias((prev) => {
            const merged = { ...prev };

            Object.keys(data.dias).forEach((key) => {
              merged[key] = criarDia({
                ...prev[key],
                ...data.dias[key],
              });
            });

            return merged;
          });
        }
      } catch (err) {
        console.error("Erro ao carregar automação", err);
      }
    };

    carregarConfig();
  }, [accessToken, cnpj]);


  const carregarStatus = async () => {
    try {
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };

      const { data } = await axios.get(
        `https://apicontabil.techspdv.com.br/v1/vendas-robo-fila/existe/${cnpj}`,
        options
      );
      setStatus(data ? 'PROCESSANDO' : 'PARADA');
    } catch {

    }
  }


  useEffect(() => {
    const carregarFaturamentoAtual = async () => {
      if (!accessToken || !lojaIdSafe) {
        setFaturamentoAtual(0);
        return;
      }

      try {
        const options = {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
        };

        const { data } = await axios.get(
          `https://apicontabil.techspdv.com.br/v1/historico-documentos-fiscais/valor-emitido-mes-atual?cnpj=${encodeURIComponent(
            cnpj
          )}`,
          options
        );

        setFaturamentoAtual(Number(data?.valorTotal || 0));
        setVendasLoja(Number(data?.valorLoja || 0));
        setVendasRobo(Number(data?.valorRobo || 0));
        setMetaDia({
          metaDiariaCalculada: Number(data?.metaDiariaCalculada ?? 0),
          valorEmitidoHoje: Number(data?.valorEmitidoHoje ?? 0),
          valorRestanteHoje: Number(data?.valorRestanteHoje ?? 0),
          valorLojaHoje: Number(data?.valorLojaHoje ?? 0),
          valorRoboHoje: Number(data?.valorRoboHoje ?? 0),
          quantidadeDeVendas: Number(data?.quantidadeDeVendas ?? 0),
          quantidadeDeVendasFeitas: Number(data?.quantidadeDeVendasFeitas ?? 0),
        });

        await carregarStatus();
      } catch (err) {
        console.error("Erro ao carregar faturamento atual", err);
        setFaturamentoAtual(0);
      }
    };

    carregarFaturamentoAtual();
  }, [accessToken, lojaIdSafe, cnpj, reload]);

  const normalizarCodigoForma = (forma) => {
    if (!forma) return null;
    if (typeof forma === "object") return forma.codigo || null;
    return forma;
  };

  const montarFormaPagamentoJson = (codigo) => {
    if (!codigo) return null;

    const encontrada = formasDePagamento.find((f) => f.value === codigo);

    return {
      codigo,
      descricao: encontrada?.label || codigo,
    };
  };

  const handleSalvar = async () => {
    const options = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };

    const payload = {
      horarioDefault,
      faixaDefault,
      vendasDefault,
      dias,
      metaMensal,
      formasPagamento: {
        formaPagamento1: montarFormaPagamentoJson(
          normalizarCodigoForma(formasPagamentoConfig.formaPagamento1)
        ),
        formaPagamento2: montarFormaPagamentoJson(
          normalizarCodigoForma(formasPagamentoConfig.formaPagamento2)
        ),
        formaPagamento3: montarFormaPagamentoJson(
          normalizarCodigoForma(formasPagamentoConfig.formaPagamento3)
        ),
      },
      formula: {
        somaMaioresRanges,
        mediaMaioresRanges,
        diasDesmarcados,
      },
    };

    try {
      await axios.post(
        `https://apicontabil.techspdv.com.br/v1/automacao/salvar/${cnpj}`,
        payload,
        options
      );

      message.success("Configurações salvas com sucesso");
    } catch (err) {
      console.error(err);
      message.error("Erro ao salvar configuração");
    }
  };
  const confirmarExcluirAutomacao = () => {
    Modal.confirm({
      title: "Excluir automação?",
      content: "Isso apagará todas as configurações da automação.",
      okText: "Sim, excluir",
      cancelText: "Cancelar",
      okType: "danger",
      onOk: handleExcluirAutomacao,
    });
  };
  const handleExcluirAutomacao = async () => {
    const options = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };

    try {
      await axios.delete(
        `https://apicontabil.techspdv.com.br/v1/automacao/excluir/${cnpj}`,
        options
      );

      message.success("Automação excluída com sucesso");
      setReload(!reload);
    } catch (err) {
      console.error(err);
      message.error("Erro ao excluir automação");
    }
  };

  const confirmarLimparFila = () => {
    Modal.confirm({
      title: "Tem certeza?",
      content: "Isso irá apagar toda a fila do robô dessa loja.",
      okText: "Sim, limpar",
      cancelText: "Cancelar",
      onOk: handleLimparFila,
    });
  };
  const handleLimparFila = async () => {

    const options = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };

    try {
      await axios.delete(
        `https://apicontabil.techspdv.com.br/v1/vendas-robo-fila/cnpj/${cnpj}`,
        options
      );

      message.success("Fila do robô limpa com sucesso");
    } catch (err) {
      console.error(err);
      message.error("Erro ao limpar fila");
    }
  };

  const renderDiaCard = (diaKey) => {
    const dia = dias[diaKey];
    const usaDefaultHorario = (dia.horarios || []).length === 0;
    const usaDefaultFaixa =
      (dia.valorMinimo === null || dia.valorMinimo === undefined) &&
      (dia.valorMaximo === null || dia.valorMaximo === undefined);

    const usaDefaultQuantidade =
      (dia.quantidadeMinima === null || dia.quantidadeMinima === undefined) &&
      (dia.quantidadeMaxima === null || dia.quantidadeMaxima === undefined);

    const valorMinimoEfetivo = getValorMinimoEfetivo(dia);
    const valorMaximoEfetivo = getValorMaximoEfetivo(dia);
    const quantidadeMinimaEfetiva = getQuantidadeMinimaEfetiva(dia);
    const quantidadeMaximaEfetiva = getQuantidadeMaximaEfetiva(dia);

    return (
      <DiaCard
        key={diaKey}
        $disabled={!dia.ativo}
        title={
          <HeaderDia>
            <Space align="center" size={10}>
              <Checkbox
                checked={dia.ativo}
                onChange={() => toggleDiaAtivo(diaKey)}
              />
              <TituloDia>{nomesDias[diaKey]}</TituloDia>
            </Space>

            {!dia.ativo ? (
              <Tag color="default">Inativo</Tag>
            ) : (
              <Space size={6} wrap>
                {usaDefaultFaixa ? (
                  <Tag color="gold">Faixa padrão</Tag>
                ) : (
                  <Tag color="green">Faixa própria</Tag>
                )}

                {usaDefaultQuantidade ? (
                  <Tag color="purple">Qtd. padrão</Tag>
                ) : (
                  <Tag color="magenta">Qtd. própria</Tag>
                )}

                {usaDefaultHorario ? (
                  <Tag color="blue">Horário padrão</Tag>
                ) : (
                  <Tag color="cyan">Horário próprio</Tag>
                )}
              </Space>
            )}
          </HeaderDia>
        }
      >
        <ConteudoDia>
          <LinhaCabecalhoHorarios>
            <SecaoTitulo>
              <DollarOutlined />
              <span>Faixa do dia</span>
            </SecaoTitulo>

            <Button
              size="small"
              onClick={() => limparFaixaDoDia(diaKey)}
              disabled={!dia.ativo}
              style={{
                backgroundColor: '#000',
                borderColor: '#000',
                color: '#fff'
              }}
            >
              Usar padrão
            </Button>
          </LinhaCabecalhoHorarios>

          <Row gutter={[10, 10]}>
            <Col span={12}>
              <Label>De</Label>
              <InputNumber
                style={{ width: "100%" }}
                value={dia.valorMinimo}
                precision={2}
                decimalSeparator=","
                min={0}
                disabled={!dia.ativo}
                placeholder={
                  faixaDefault.valorMinimo !== null &&
                    faixaDefault.valorMinimo !== undefined
                    ? `Default: ${formatarMoeda(faixaDefault.valorMinimo)}`
                    : "Sem default"
                }
                onChange={(v) => {
                  const valor = v ?? null;

                  if (valor !== null && valor < 0) return;

                  // se "de" for maior que "até", corrige automaticamente
                  if (
                    valor !== null &&
                    dia.valorMaximo !== null &&
                    dia.valorMaximo !== undefined &&
                    valor > dia.valorMaximo
                  ) {
                    atualizarDia(diaKey, {
                      valorMinimo: valor,
                      valorMaximo: valor,
                    });
                    return;
                  }

                  atualizarDia(diaKey, { valorMinimo: valor });
                }}
                formatter={formatterNumero}
                parser={parserNumero}
              />
            </Col>

            <Col span={12}>
              <Label>Até</Label>
              <InputNumber
                style={{ width: "100%" }}
                precision={2}
                decimalSeparator=","
                value={dia.valorMaximo}
                min={0}
                disabled={!dia.ativo}
                placeholder={
                  faixaDefault.valorMaximo !== null &&
                    faixaDefault.valorMaximo !== undefined
                    ? `Default: ${faixaDefault.valorMaximo}`
                    : "Sem default"
                }
                onChange={(v) => {
                  const valor = v ?? null;

                  if (valor !== null && valor < 0) return;

                  // bloqueia se "até" for menor que "de"
                  if (
                    valor !== null &&
                    dia.valorMinimo !== null &&
                    dia.valorMinimo !== undefined &&
                    valor < dia.valorMinimo
                  ) {
                    return; // não deixa atualizar
                  }

                  atualizarDia(diaKey, { valorMaximo: valor });
                }}
                formatter={formatterNumero}
                parser={parserNumero}
              />
            </Col>
          </Row>

          <ResumoFaixa>
            Faixa efetiva: <strong>{formatarMoeda(valorMinimoEfetivo)}</strong>{" "}
            até <strong>{formatarMoeda(valorMaximoEfetivo)}</strong>
          </ResumoFaixa>

          {usaDefaultFaixa && (
            <DefaultBox style={{ marginTop: 10 }}>
              <Text strong>Usando faixa padrão</Text>
              <Text>
                {formatarMoeda(faixaDefault.valorMinimo)} até{" "}
                {formatarMoeda(faixaDefault.valorMaximo)}
              </Text>
            </DefaultBox>
          )}

          <Divider style={{ margin: "14px 0" }} />

          <LinhaCabecalhoHorarios>
            <SecaoTitulo>
              <DashboardOutlined />
              <span>Quantidade de vendas do dia</span>
            </SecaoTitulo>

            <Button
              size="small"
              onClick={() => limparQuantidadeDoDia(diaKey)}
              disabled={!dia.ativo}
              style={{
                backgroundColor: '#000',
                borderColor: '#000',
                color: '#fff'
              }}
            >
              Usar padrão
            </Button>
          </LinhaCabecalhoHorarios>

          <Row gutter={[10, 10]}>
            <Col span={12}>
              <Label>De vendas</Label>
              <InputNumber
                style={{ width: "100%" }}
                value={dia.quantidadeMinima}
                min={0}
                precision={0}
                disabled={!dia.ativo}
                placeholder={
                  vendasDefault.quantidadeMinima !== null &&
                    vendasDefault.quantidadeMinima !== undefined
                    ? `Default: ${vendasDefault.quantidadeMinima}`
                    : "Sem default"
                }
                onChange={(v) => {
                  const valor = v ?? null;

                  if (valor !== null && valor < 0) return;

                  if (
                    valor !== null &&
                    dia.quantidadeMaxima !== null &&
                    dia.quantidadeMaxima !== undefined &&
                    valor > dia.quantidadeMaxima
                  ) {
                    atualizarDia(diaKey, {
                      quantidadeMinima: valor,
                      quantidadeMaxima: valor,
                    });
                    return;
                  }

                  atualizarDia(diaKey, { quantidadeMinima: valor });
                }}
              />
            </Col>

            <Col span={12}>
              <Label>Até vendas</Label>
              <InputNumber
                style={{ width: "100%" }}
                value={dia.quantidadeMaxima}
                min={0}
                precision={0}
                disabled={!dia.ativo}
                placeholder={
                  vendasDefault.quantidadeMaxima !== null &&
                    vendasDefault.quantidadeMaxima !== undefined
                    ? `Default: ${vendasDefault.quantidadeMaxima}`
                    : "Sem default"
                }
                onChange={(v) => {
                  const valor = v ?? null;

                  if (valor !== null && valor < 0) return;

                  if (
                    valor !== null &&
                    dia.quantidadeMinima !== null &&
                    dia.quantidadeMinima !== undefined &&
                    valor < dia.quantidadeMinima
                  ) {
                    return;
                  }

                  atualizarDia(diaKey, { quantidadeMaxima: valor });
                }}
              />
            </Col>
          </Row>

          <ResumoFaixa>
            Quantidade efetiva: <strong>{quantidadeMinimaEfetiva}</strong> até{" "}
            <strong>{quantidadeMaximaEfetiva}</strong> vendas
          </ResumoFaixa>

          {usaDefaultQuantidade && (
            <DefaultBox style={{ marginTop: 10 }}>
              <Text strong>Usando quantidade padrão</Text>
              <Text>
                {Number(vendasDefault.quantidadeMinima || 0)} até{" "}
                {Number(vendasDefault.quantidadeMaxima || 0)} vendas
              </Text>
            </DefaultBox>
          )}

          <Divider style={{ margin: "14px 0" }} />

          <LinhaCabecalhoHorarios>
            <SecaoTitulo>
              <ClockCircleOutlined />
              <span>Horários</span>
            </SecaoTitulo>

            <Button
              size="small"
              icon={<PlusOutlined />}
              onClick={() => adicionarHorario(diaKey)}
              disabled={!dia.ativo}
              style={{
                backgroundColor: '#000',
                borderColor: '#000',
                color: '#fff'
              }}
            >
              Adicionar
            </Button>
          </LinhaCabecalhoHorarios>

          {usaDefaultHorario ? (
            <DefaultBox>
              <Text strong>Usando horário padrão</Text>
              <Text>{formatarHorario(horarioDefault)}</Text>
            </DefaultBox>
          ) : (
            <ListaHorarios>
              {dia.horarios.map((horario, index) => (
                <HorarioItem key={`${diaKey}-${index}`}>
                  <TimePicker
                    style={{ width: "100%" }}
                    format="HH:mm"
                    value={toDayjsTime(horario.inicio, "08:00")}
                    onChange={(time) =>
                      atualizarHorario(
                        diaKey,
                        index,
                        "inicio",
                        time ? time.format("HH:mm") : "08:00"
                      )
                    }
                    disabled={!dia.ativo}
                  />

                  <SeparadorHorario>até</SeparadorHorario>

                  <TimePicker
                    style={{ width: "100%" }}
                    format="HH:mm"
                    value={toDayjsTime(horario.fim, "18:00")}
                    onChange={(time) =>
                      atualizarHorario(
                        diaKey,
                        index,
                        "fim",
                        time ? time.format("HH:mm") : "18:00"
                      )
                    }
                    disabled={!dia.ativo}
                  />

                  <Button
                    icon={<DeleteOutlined />}
                    onClick={() => removerHorario(diaKey, index)}
                    disabled={!dia.ativo}
                    style={{
                      backgroundColor: '#ff4d4f',
                      borderColor: '#ff4d4f',
                      color: '#fff'
                    }}
                  />
                </HorarioItem>
              ))}
            </ListaHorarios>
          )}
        </ConteudoDia>
      </DiaCard>
    );
  };

  return (
    <Container>
      <Topo>
        <CardResumoPrincipal>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {/* ESQUERDA */}
            <Space size={10}>
              <IconeCircle>
                <DashboardOutlined />
              </IconeCircle>

              <div>
                <Title level={4} style={{ margin: 0 }}>
                  Meta mensal
                </Title>
                <Text type="secondary">
                  <b style={{ color: "black", fontSize: "20px" }}>
                    Meta aproximada baseada na faixa diária
                  </b>
                </Text>
              </div>
            </Space>

            {/* DIREITA */}
            <BtnBlack icon={<ReloadOutlined />}
              //loading={loading}
              onClick={() => { setReload(!reload); }}>
              Atualizar Painel
            </BtnBlack>
          </div>
          <ValorDestaque>{formatarMoeda(metaMensal)}</ValorDestaque>

          <Row gutter={[16, 12]}>
            <Col xs={24} md={12}>
              <MiniInfoBox>
                <MiniInfoLabel>Faturamento atual</MiniInfoLabel>
                <MiniInfoValor>{formatarMoeda(faturamentoAtual)}</MiniInfoValor>
              </MiniInfoBox>
            </Col>
            <Col xs={24} md={12}>
              <MiniInfoBox>
                <MiniInfoLabel>Loja selecionada</MiniInfoLabel>
                <MiniInfoValor>{nome || "-"}</MiniInfoValor>
              </MiniInfoBox>
            </Col>
          </Row>

          <Progress
            percent={Number(percentualMeta.toFixed(1))}
            style={{ marginTop: 18 }}
          />

          <Divider />

          <Title level={5} style={{ marginTop: 0, marginBottom: 16 }}>
            Faturamento / emissão atual
          </Title>

          <ResumoLinha>
            <span>Loja</span>
            <strong>{formatarMoeda(loja)}</strong>
          </ResumoLinha>

          <ResumoLinha>
            <span>Robô</span>
            <strong>{formatarMoeda(robo)}</strong>
          </ResumoLinha>

          <Divider style={{ margin: "12px 0" }} />

          <ResumoLinha>
            <span>Total</span>
            <TotalTexto>{formatarMoeda(totalEmissao)}</TotalTexto>
          </ResumoLinha>

          <MetaDoDia
            metaDiariaCalculada={metaDia.metaDiariaCalculada}
            valorEmitidoHoje={metaDia.valorEmitidoHoje}
            valorRestanteHoje={metaDia.valorRestanteHoje}
            valorLojaHoje={metaDia.valorLojaHoje}
            valorRoboHoje={metaDia.valorRoboHoje}
            quantidadeDeVendas={metaDia.quantidadeDeVendas}
            quantidadeDeVendasFeitas={metaDia.quantidadeDeVendasFeitas}
            status={status}
          />

        </CardResumoPrincipal>

        <CardBloco>
          <TopoCardHeader>
            <Space size={10}>
              <IconeCircle>
                <DollarOutlined />
              </IconeCircle>
              <div>
                <Title level={5} style={{ margin: 0 }}>
                  Padrões
                </Title>
                <Text type="secondary">
                  Caso prefira uma meta diaria padrão, quantidade de vendas
                  padrão ou horários padrões defina aqui.
                </Text>
              </div>


            </Space>
          </TopoCardHeader>

          <BlocoDefaultSection>
            <SecaoTitulo>
              <DollarOutlined />
              <span>Faixa padrão</span>
            </SecaoTitulo>

            <Row gutter={[12, 12]}>
              <Col span={12}>
                <Label>De</Label>
                <InputNumber
                  style={{ width: "100%" }}
                  value={faixaDefault.valorMinimo}
                  precision={2}
                  decimalSeparator=","
                  min={0}
                  placeholder="Ex.: 30"
                  onChange={(v) => {
                    const valor = v ?? null;



                    setFaixaDefault((prev) => {
                      if (
                        valor !== null &&
                        prev.valorMaximo !== null &&
                        prev.valorMaximo !== undefined &&
                        valor > prev.valorMaximo
                      ) {
                        return {
                          ...prev,
                          valorMinimo: valor,
                          valorMaximo: valor,
                        };
                      }

                      return {
                        ...prev,
                        valorMinimo: valor,
                      };
                    });
                  }}
                  formatter={formatterNumero}
                  parser={parserNumero}
                />
              </Col>

              <Col span={12}>
                <Label>Até</Label>
                <InputNumber
                  style={{ width: "100%" }}
                  value={faixaDefault.valorMaximo}
                  precision={2}
                  decimalSeparator=","
                  min={0}
                  placeholder="Ex.: 50"
                  onChange={(v) => {
                    const valor = v ?? null;

                    if (valor !== null && valor < 0) return;

                    setFaixaDefault((prev) => {
                      if (
                        valor !== null &&
                        prev.valorMinimo !== null &&
                        prev.valorMinimo !== undefined &&
                        valor < prev.valorMinimo
                      ) {
                        return prev;
                      }

                      return {
                        ...prev,
                        valorMaximo: valor,
                      };
                    });
                  }}
                  formatter={formatterNumero}
                  parser={parserNumero}
                />
              </Col>
            </Row>
            <PainelDefault>
              <Text type="secondary">Faixa padrão atual</Text>
              <DefaultResumoGrande>
                {formatarMoeda(faixaDefault.valorMinimo)} até{" "}
                {formatarMoeda(faixaDefault.valorMaximo)}
              </DefaultResumoGrande>
            </PainelDefault>
          </BlocoDefaultSection>

          <Divider />

          <BlocoDefaultSection>
            <SecaoTitulo>
              <DashboardOutlined />
              <span>Quantidade padrão de vendas</span>
            </SecaoTitulo>

            <Row gutter={[12, 12]}>
              <Col span={12}>
                <Label>De vendas</Label>
                <InputNumber
                  style={{ width: "100%" }}
                  value={vendasDefault.quantidadeMinima}
                  min={0}
                  precision={0}
                  placeholder="Ex.: 10"
                  onChange={(v) => {
                    const valor = v ?? null;

                    if (valor !== null && valor < 0) return;

                    setVendasDefault((prev) => {
                      if (
                        valor !== null &&
                        prev.quantidadeMaxima !== null &&
                        prev.quantidadeMaxima !== undefined &&
                        valor > prev.quantidadeMaxima
                      ) {
                        return {
                          ...prev,
                          quantidadeMinima: valor,
                          quantidadeMaxima: valor,
                        };
                      }

                      return {
                        ...prev,
                        quantidadeMinima: valor,
                      };
                    });
                  }}
                />
              </Col>

              <Col span={12}>
                <Label>Até vendas</Label>
                <InputNumber
                  style={{ width: "100%" }}
                  value={vendasDefault.quantidadeMaxima}
                  min={0}
                  precision={0}
                  placeholder="Ex.: 16"
                  onChange={(v) => {
                    const valor = v ?? null;

                    if (valor !== null && valor < 0) return;

                    setVendasDefault((prev) => {
                      if (
                        valor !== null &&
                        prev.quantidadeMinima !== null &&
                        prev.quantidadeMinima !== undefined &&
                        valor < prev.quantidadeMinima
                      ) {
                        return prev;
                      }

                      return {
                        ...prev,
                        quantidadeMaxima: valor,
                      };
                    });
                  }}
                />
              </Col>
            </Row>

            <PainelDefault>
              <Text type="secondary">Quantidade padrão atual</Text>
              <DefaultResumoGrande>
                {Number(vendasDefault.quantidadeMinima || 0)} até{" "}
                {Number(vendasDefault.quantidadeMaxima || 0)} vendas
              </DefaultResumoGrande>
            </PainelDefault>
          </BlocoDefaultSection>

          <Divider />

          <BlocoDefaultSection>
            <SecaoTitulo>
              <ClockCircleOutlined />
              <span>Horário padrão</span>
            </SecaoTitulo>

            <Row gutter={[12, 12]}>
              <Col span={12}>
                <Label>Das</Label>
                <TimePicker
                  style={{ width: "100%" }}
                  format="HH:mm"
                  value={toDayjsTime(horarioDefault.inicio, "08:00")}
                  onChange={(time) =>
                    setHorarioDefault((prev) => ({
                      ...prev,
                      inicio: time ? time.format("HH:mm") : "08:00",
                    }))
                  }
                />
              </Col>

              <Col span={12}>
                <Label>Às</Label>
                <TimePicker
                  style={{ width: "100%" }}
                  format="HH:mm"
                  value={toDayjsTime(horarioDefault.fim, "18:00")}
                  onChange={(time) =>
                    setHorarioDefault((prev) => ({
                      ...prev,
                      fim: time ? time.format("HH:mm") : "18:00",
                    }))
                  }
                />
              </Col>
            </Row>

            <PainelDefault>
              <Text type="secondary">Horário padrão atual</Text>
              <DefaultResumoGrande>
                {formatarHorario(horarioDefault)}
              </DefaultResumoGrande>
            </PainelDefault>
          </BlocoDefaultSection>



          <div style={{ marginTop: 16 }}>
            <SecaoTitulo>
              <CreditCardOutlined /> Formas de Pagamento
            </SecaoTitulo>
            <Row gutter={[12, 12]}>
              {/* FORMA 1 */}
              <Col xs={24} md={8}>
                <Label>Forma 1</Label>
                <Select
                  style={{ width: "100%" }}
                  placeholder="Forma de pagamento 1"
                  value={formasPagamentoConfig.formaPagamento1}
                  onChange={(value) =>
                    setFormasPagamentoConfig((prev) => ({
                      ...prev,
                      formaPagamento1: value || "01",
                    }))
                  }
                  options={formasDePagamento}
                />
              </Col>

              {/* FORMA 2 */}
              <Col xs={24} md={8}>
                <Label>Forma 2</Label>
                <Select
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="Forma de pagamento 2"
                  value={formasPagamentoConfig.formaPagamento2}
                  onChange={(value) =>
                    setFormasPagamentoConfig((prev) => ({
                      ...prev,
                      formaPagamento2: value || null,
                    }))
                  }
                  options={formasDePagamento}
                />
              </Col>

              {/* FORMA 3 */}
              <Col xs={24} md={8}>
                <Label>Forma 3</Label>
                <Select
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="Forma de pagamento 3"
                  value={formasPagamentoConfig.formaPagamento3}
                  onChange={(value) =>
                    setFormasPagamentoConfig((prev) => ({
                      ...prev,
                      formaPagamento3: value || null,
                    }))
                  }
                  options={formasDePagamento}
                />
              </Col>
            </Row>
          </div>
        </CardBloco>


      </Topo>

      <LinhaDias>
        {renderDiaCard("segunda")}
        {renderDiaCard("terca")}
        {renderDiaCard("quarta")}
        {renderDiaCard("quinta")}
      </LinhaDias>

      <LinhaDias>
        {renderDiaCard("sexta")}
        {renderDiaCard("sabado")}
        {renderDiaCard("domingo")}
      </LinhaDias>

      <LinhaCentro>
        <AreaBotao>
          <BotaoExcluirAutomacao
            icon={<DeleteOutlined />}
            onClick={confirmarExcluirAutomacao}
          >
            EXCLUIR AUTOMAÇÃO
          </BotaoExcluirAutomacao>

          <BotaoParar
            icon={<ClearOutlined />}
            onClick={confirmarLimparFila}
          >
            PARAR AUTOMAÇÃO
          </BotaoParar>
          <BotaoSalvar
            icon={<SaveOutlined />}
            size="large"
            onClick={handleSalvar}
          >
            SALVAR ALTERAÇÕES
          </BotaoSalvar>
        </AreaBotao>
      </LinhaCentro>
    </Container>
  );
};

export default Automacao;

const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  padding: 24px;
  background: radial-gradient(
    circle at top left,
    #eef5ff 0%,
    #f7f9fc 40%,
    #f5f7fb 100%
  );
  box-sizing: border-box;
  margin-bottom: 50px;
`;

const Topo = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 16px;
  margin-bottom: 20px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

const BaseCard = styled(Card)`
  border-radius: 20px;
  border: 1px solid #e8edf5;
  box-shadow: 0 6px 22px rgba(16, 24, 40, 0.05);

  .ant-card-head {
    border-bottom: none;
    min-height: auto;
    padding: 14px 18px 0;
  }

  .ant-card-body {
    padding: 18px;
  }
`;

const CardBloco = styled(BaseCard)``;

const CardResumoPrincipal = styled(BaseCard)`
  .ant-card-body {
    padding: 20px;
  }
`;

const TopoCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;



const BtnBlack = styled(Button)`
  background: #000 !important;
  border-color: #000 !important;
  color: #fff !important;
  font-weight: 600;

  .anticon {
    color: #fff !important;
  }

  &:hover {
    background: #111 !important;
    border-color: #111 !important;
    color: #fff !important;
  }

  &:disabled {
    background: #ccc !important;
    border-color: #ccc !important;
    color: #666 !important;
  }
`;

const BtnRed = styled(Button)`
  background: #b32c2c !important;
  border-color: #b32c2c !important;
  color: #fff !important;
  font-weight: 600;

  .anticon {
    color: #fff !important;
  }

  &:hover {
    background: #b32c2c !important;
    border-color: #b32c2c !important;
    color: #fff !important;
  }

  &:disabled {
    background: #ccc !important;
    border-color: #ccc !important;
    color: #666 !important;
  }
`;

const IconeCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: linear-gradient(135deg, #1677ff, #69a7ff);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
`;

const ValorDestaque = styled.div`
  font-size: 34px;
  font-weight: 800;
  color: #1677ff;
  margin: 18px 0 16px;
  line-height: 1;
`;

const MiniInfoBox = styled.div`
  background: #f7faff;
  border: 1px solid #d9e8ff;
  border-radius: 14px;
  padding: 12px;
`;

const MiniInfoLabel = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 4px;
`;

const MiniInfoValor = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #111827;
`;

const BlocoDefaultSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.div`
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #475467;
`;

const PainelDefault = styled.div`
  margin-top: 18px;
  padding: 14px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f7fbff 0%, #eef6ff 100%);
  border: 1px solid #d8eaff;
`;

const DefaultResumoGrande = styled.div`
  margin-top: 6px;
  font-size: 24px;
  font-weight: 800;
  color: #1677ff;
`;

const LinhaDias = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

const LinhaCentro = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 18px;
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

const DiaCard = styled(BaseCard)`
  opacity: ${(props) => (props.$disabled ? 0.82 : 1)};
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 28px rgba(16, 24, 40, 0.08);
  }

  .ant-card-head-title {
    overflow: visible;
    white-space: normal;
  }
`;

const HeaderDia = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const TituloDia = styled.span`
  font-weight: 800;
  font-size: 15px;
  color: #111827;
`;

const ConteudoDia = styled.div`
  display: flex;
  flex-direction: column;
`;

const SecaoTitulo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 8px;
`;

const ResumoFaixa = styled.div`
  margin-top: 10px;
  font-size: 13px;
  color: #6b7280;
`;

const LinhaCabecalhoHorarios = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const DefaultBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  border: 1px dashed #91caff;
  background: #f0f7ff;
  border-radius: 14px;
  padding: 12px;
`;

const ListaHorarios = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const HorarioItem = styled.div`
  display: grid;
  grid-template-columns: minmax(90px, 1fr) auto minmax(90px, 1fr) 40px;
  gap: 8px;
  align-items: center;

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

const SeparadorHorario = styled.span`
  font-size: 12px;
  color: #667085;
  text-align: center;
`;

const ResumoLinha = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  font-size: 15px;
  color: #111827;
`;

const TotalTexto = styled.span`
  font-size: 18px;
  font-weight: 800;
  color: #1677ff;
`;

const AreaBotao = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  gap:20px
`;

const BotaoSalvar = styled(Button)`
  && {
    min-width: 300px;
    height: 52px;
    border-radius: 14px;
    font-weight: 800;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);

    background: #000 !important;
    background-color: #000 !important;
    border-color: #000 !important;
    color: #fff !important;
  }

  &&:hover,
  &&:focus,
  &&.ant-btn-primary:hover,
  &&.ant-btn-primary:focus {
    background: #222 !important;
    background-color: #222 !important;
    border-color: #222 !important;
    color: #fff !important;
  }

  &&:active,
  &&.ant-btn-primary:active {
    background: #111 !important;
    background-color: #111 !important;
    border-color: #111 !important;
    color: #fff !important;
  }

  &&:disabled,
  &&.ant-btn-primary:disabled {
    background: #444 !important;
    background-color: #444 !important;
    border-color: #444 !important;
    color: #bbb !important;
    box-shadow: none;
  }
`;

const BotaoParar = styled(Button)`
  && {
    min-width: 300px;
    height: 52px;
    border-radius: 14px;
    font-weight: 800;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);

    background: #ce1010 !important;
    background-color: #ce1010 !important;
    border-color: #ce1010 !important;
    color: #fff !important;
  }

  &&:hover,
  &&:focus,
  &&.ant-btn-primary:hover,
  &&.ant-btn-primary:focus {
    background: #ee0b0b !important;
    background-color: #ee0b0b !important;
    border-color: #ee0b0b !important;
    color: #fff !important;
  }

  &&:active,
  &&.ant-btn-primary:active {
    background: #111 !important;
    background-color: #111 !important;
    border-color: #111 !important;
    color: #fff !important;
  }

  &&:disabled,
  &&.ant-btn-primary:disabled {
    background: #444 !important;
    background-color: #444 !important;
    border-color: #444 !important;
    color: #bbb !important;
    box-shadow: none;
  }
`;


const BotaoExcluirAutomacao = styled(Button)`
  && {
    min-width: 300px;
    height: 52px;
    border-radius: 14px;
    font-weight: 800;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);

    background: #740a0a !important;
    background-color: #740a0a !important;
    border-color: #740a0a !important;
    color: #fff !important;
  }

  &&:hover,
  &&:focus,
  &&.ant-btn-primary:hover,
  &&.ant-btn-primary:focus {
    background: #860808 !important;
    background-color: #860808 !important;
    border-color: #860808 !important;
    color: #fff !important;
  }

  &&:active,
  &&.ant-btn-primary:active {
    background: #111 !important;
    background-color: #111 !important;
    border-color: #111 !important;
    color: #fff !important;
  }

  &&:disabled,
  &&.ant-btn-primary:disabled {
    background: #444 !important;
    background-color: #444 !important;
    border-color: #444 !important;
    color: #bbb !important;
    box-shadow: none;
  }
`;